
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advice",
      function () {
        return require("private-next-pages/advice/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advice"])
      });
    }
  